import { createSlice } from '@reduxjs/toolkit';
import { getCities } from './operations';

const handlePending = state => {
  state.status = 'pending';
  state.error = null;
};
const handleRejected = (state, action, status = 'rejected') => {
  state.status = status;
  state.error = action.payload;
};
const handleFulfilled = (state, status = 'fulfilled') => {
  state.status = status;
  state.error = null;
};

const initialState = {};

export const locationsSlice = createSlice({
  name: 'locations',
  initialState,
  extraReducers: builder =>
    builder
      .addCase(getCities.pending, (state, action) => { handlePending(state); })
      .addCase(getCities.rejected, (state, action) => { handleRejected(state, action); })
      .addCase(getCities.fulfilled, (state, action) => { handleFulfilled(state);
        state.list = action.payload;
      }),
});

export const locationsReducer = locationsSlice.reducer;